import { useState } from "react";
import OrdiniFornitori from "./OrdiniFornitori";
import { ShoppingCart, Package } from "lucide-react";

const TABS = [
  { key: "food", label: "Food & Beverage", icon: ShoppingCart },
  { key: "materiali", label: "Attrezzature & Packaging", icon: Package },
];

const OrdiniPage = () => {
  const [activeTab, setActiveTab] = useState("food");

  return (
    <div className="space-y-6" data-testid="ordini-page">
      {/* Header — stesso stile Fornitori */}
      <div className="hidden md:block">
        <h1 className="text-3xl font-bold text-foreground">Ordini</h1>
        <p className="text-muted-foreground mt-1">Gestione ordini ai fornitori e prodotti da riordinare</p>
      </div>

      {/* Tab selector — stile Fornitori (h-14 rounded-2xl pill) */}
      <div className="flex gap-2">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            data-testid={`tab-ordini-${key}`}
            className={`h-14 px-5 rounded-2xl font-semibold flex items-center gap-2 transition-all text-sm ${
              activeTab === key
                ? "bg-primary text-white shadow-sm"
                : "bg-muted text-muted-foreground hover:bg-muted/80 border border-border"
            }`}
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{label}</span>
          </button>
        ))}
      </div>

      <OrdiniFornitori area={activeTab} key={activeTab} hideHeader={true} />
    </div>
  );
};

export default OrdiniPage;
